import { useLocation, Navigate, Outlet } from "react-router-dom"
import useAuth from "../../hooks/useAuth"

const RequireAuth = ({ app, allowedRoles = [] }) => {
    const location = useLocation()
    const { isGlobalAdmin, accessibleApps, hasAppRole, platformRoles = [] } = useAuth()

    if (isGlobalAdmin) {
        return <Outlet />
    }

    // pure platform-role route
    if (!app && allowedRoles.length > 0) {
        const hasPlatformRole = allowedRoles.some(role => platformRoles.includes(role))
        return hasPlatformRole
            ? <Outlet />
            : <Navigate to="/login" state={{ from: location }} replace />
    }

    if (app && !accessibleApps.includes(app)) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (!allowedRoles || allowedRoles.length === 0) {
        return <Outlet />
    }

    const hasRequiredRole = allowedRoles.some(role => hasAppRole(app, role))

    return hasRequiredRole
        ? <Outlet />
        : <Navigate to="/login" state={{ from: location }} replace />
}

export default RequireAuth